declare global {
  interface Window {
    _env_?: Record<string, string>;
  }
}

function env(key: string): string | undefined {
  const injected = window._env_?.[key]?.trim();
  if (injected) return injected;
  // Trim the local-dev fallback too — a whitespace-only .env value must be
  // treated as unset, otherwise isBffConfigured() can wrongly report the
  // studio as "protected" while Okta is actually unusable.
  const fallback = (import.meta.env[key] as string | undefined)?.trim();
  return fallback ? fallback : undefined;
}

export const config = {
  oktaIssuer:   env('VITE_OKTA_ISSUER')    ?? '',
  oktaClientId: env('VITE_OKTA_CLIENT_ID') ?? '',
  bffUrl:       env('VITE_BFF_URL')        ?? '',
};

export function isBffConfigured(): boolean {
  return !!(config.oktaIssuer && config.oktaClientId && config.bffUrl);
}
